const Vr7 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-7/PNG%20n.2/3d%20%207-2/publish%207-2/`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 7 Tour"
        ></iframe>
      </div>
    );
};

export default Vr7;
